import "@/App.css";
import { BrowserRouter, Routes, Route, ScrollRestoration } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { Toaster } from "@/components/ui/sonner";

import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import ScrollToTop from "@/components/layout/ScrollToTop";

import Home from "@/pages/Home";
import Groupe from "@/pages/Groupe";
import Ecosysteme from "@/pages/Ecosysteme";
import Projets from "@/pages/Projets";
import Impact from "@/pages/Impact";
import Actualites from "@/pages/Actualites";
import Carrieres from "@/pages/Carrieres";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App bg-ekip-cream text-ekip-slate font-body min-h-screen flex flex-col">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/groupe" element={<Groupe />} />
              <Route path="/ecosysteme" element={<Ecosysteme />} />
              <Route path="/projets" element={<Projets />} />
              <Route path="/impact" element={<Impact />} />
              <Route path="/actualites" element={<Actualites />} />
              <Route path="/carrieres" element={<Carrieres />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
